<div class="{{ colorScheme().backgroundClass }} px-3 py-12px">
  <div class="row">
    <div class="col align-self-center">
      <div class="text-center" [ngClass]="colorScheme().textColorClass" [attr.title]="text() | translate">
        @if (iconClass()) {
          <i
            class="fas mr-2 vertical-align-middle {{ iconClass() }} {{ colorScheme().iconColorClass }}"
            aria-hidden="true"
            style="font-size: 1.5rem"
          ></i>
        } @else {
          <i
            class="fas mr-2 vertical-align-middle {{ colorScheme().iconClass }} {{ colorScheme().iconColorClass }}"
            aria-hidden="true"
            style="font-size: 1.5rem"
          ></i>
        }
        @if (text()) {
          <span class="vertical-align-middle" [innerHTML]="text() | translate | safeHtml"></span>
        } @else {
          <span class="vertical-align-middle">
            <ng-content />
          </span>
        }
      </div>
    </div>
    @if (isClosable()) {
      <div class="col-auto">
        <div class="col-auto">
          <mwe-button
            title="Close"
            category="tertiary"
            [color]="colorScheme().closeBtnColor || 'white'"
            type="button"
            (clicked)="close()"
            size="sm"
            prependIconClass=""
            [isIconBtn]="true"
          >
            <i class="fas fa-xmark" aria-hidden="true"></i>
          </mwe-button>
        </div>
      </div>
    }
  </div>
</div>
